'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var CircularProgress = require('../../Feedback/Progress/CircularProgress.js');
var makeStyles = require('../../Styles/makeStyles.js');
var classNames = require('classnames');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"]({
  blurSpinner: {
    backgroundColor: '#ffffff',
    position: 'absolute',
    zIndex: 20,
    top: 0,
    left: 0,
    opacity: 0.93,
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

var OverlayBlur = function OverlayBlur(_ref) {
  var className = _ref.className,
      SpinnerProps = objectWithoutProperties(_ref, ["className"]);

  var _useStyles = useStyles(),
      blurSpinner = _useStyles.blurSpinner;

  return React__default["default"].createElement("div", {
    className: classNames__default["default"](blurSpinner, className)
  }, React__default["default"].createElement(CircularProgress, _objectSpread({}, SpinnerProps)));
};

module.exports = OverlayBlur;
